export default "__VITE_ASSET__Bq$fx0I1__"